module.exports = __webpack_public_path__ + "img/back.28826664.png";